import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Cancel Reasons board (Audit -> Cancel Reasons) — reads Admin_GetCancelBoard on db37, which
// aggregates lk_cancel_board_fact (rebuilt nightly by LK_CancelBoardRefresh) and returns the whole
// board as one JSON object: meta, summary, reasons, cohorts, channels, leadTimes, freeText.
export default class CancelBoardService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  // days = 7 | 30 | 90, channel = "" (all) | app | website | whatsapp | store
  async getBoard(days, channel, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_CANCEL_BOARD });
    let out = {};
    await api.endpoints[this.endpoint.GET_CANCEL_BOARD]
      .getAllPost({ Days: days || 7, Channel: channel || "" })
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getBoard(days, channel, true);
        return out;
      } catch (e) {
        return { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    // The WebAPI wraps everything in SingleResponse {result,statusCode,message,data} and the proc
    // puts the board in Data as a JSON string. Reading the wrapper instead of .data is what made
    // the R-to-3 dashboard show all zeros, so unwrap then parse.
    if (out && typeof out.data === "string") {
      try { return JSON.parse(out.data); }
      catch (e) { return { error: "Could not read the Cancel Reasons response." }; }
    }
    return out && out.data !== undefined ? out.data : out;
  }
}
